import React from 'react';

import { BorderedContent } from '../BorderedContent/BorderedContent';

import './BorderedContentWithTitle.less';

interface BorderedContentWithTitleProps {
  title: string;
  children: React.ReactElement;
  className?: string;
}

export const BorderedContentWithTitle: React.FC<
  BorderedContentWithTitleProps
> = ({
  title,
  children,
  className,
}: BorderedContentWithTitleProps): React.ReactElement => {
  return (
    <BorderedContent className={className}>
      <div className={'BorderedContentWithTitle'}>
        <span>{title}</span>
      </div>
      {children}
    </BorderedContent>
  );
};
